module.exports = __webpack_public_path__ + "01fcc9ff6ebb9f2f2a9192c04b2fb382.svg";